<template>
  <edit-phone-number ref="SALARIE_NUMERO"
                     :value=value
                     :contextId=contextId
                     :editFieldInfo=editFieldInfo
                     :hideLabel='hideLabel'
                     :dataTable='dataTable'
                     :required=required
                     :disabled=readOnly
                     :showMissing=showMissing
                     @updated=setUpdated
                     @context=setInitValue
                     @error=setError>
  </edit-phone-number>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import EditBase from '@/framework/base/components/EditBase';
  import EditPhoneNumber from '@/framework/base/components/EditPhoneNumber.vue'
  import { EditFieldType, FieldInfo, getFormat } from '@/framework/base/components/FieldInfo'
  import { RessourceGenControl, GenControl } from '@/generated/ressources/generatedRessources';
  // eslint-disable-next-line
  import validator, { rules, RULES_FRENCH_LABEL } from '@/generated/validators/ValidationRules';

  export default defineComponent({
    extends: EditBase,
    components: {
      EditPhoneNumber
    },
    computed: {
      ressource () { return RessourceGenControl(GenControl.SALARIE_NUMERO); },
      editFieldInfo (): FieldInfo {
        const type = EditFieldType.PHONE;
        const precision = 2;
        const format = getFormat('');
        const focus = this.focusValidator;
        const live = this.liveValidator;
        const mask = this.mask;
        return new FieldInfo(this.ressource, type, precision, mask, format, focus, live, this.theme);
      }
    },
    methods: {
      // eslint-disable-next-line
      focusValidator (value: string): validator | null {
        return  new validator(rules.numeroValid, RULES_FRENCH_LABEL.text.numeroValid.error);
      },

      // eslint-disable-next-line
      liveValidator (value: string): validator | null {
        return null;
      },

      // eslint-disable-next-line
      mask (value: string): string {
        return 'NN NN NN NN NN';
      },

      missing (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.SALARIE_NUMERO.missing();
      },

      touch (): void {
        // @ts-expect-error : generated method
        this.$refs.SALARIE_NUMERO.touch();
      },

      setFocus (): void {
        // @ts-expect-error : generated method
        this.$refs.SALARIE_NUMERO.setFocus();
      }
    }
  })
</script>
